import React, { useRef, useEffect } from "react";
import { Move3D } from "lucide-react";
import branding from "../Assets/branding.jpg";
import ContentCreation from "../Assets/ContentCreation.jpg";
import Email from "../Assets/Email.jpg";
import Youtube from "../Assets/About/use2 (1).mp4";

const AboutSection5 = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    // <div className="min-h-screen bg-gradient-to-b from-[#704735] to-[#704735]/50 dark:from-[#704735]/90 dark:to-white">

    <div className="min-h-screen bg-[#f2efea] ">
      <div className="w-full max-w-6xl mx-auto px-6 py-16 space-y-16">
        {/* Header with animated underline */}
        <div className="text-center relative">
          <Move3D className="w-8 h-8 mx-auto mb-6 text-[#704735]" />
          <h1 className="text-xl font-semibold tracking-[0.25em] text-[#704735] dark:text-[#8b6553]">
            FOLLOW ALONG @CEG
          </h1>
          <div className="h-0.5 w-24 bg-[#704735] mx-auto mt-4 animate-pulse" />
        </div>

        {/* Main Grid with enhanced hover effects */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Instagram Column */}
          <div className="group relative flex flex-col items-center space-y-4">
            <div className="w-full aspect-square rounded-2xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-2xl">
              <div className="relative w-full h-full transform transition-transform group-hover:scale-105">
                <img
                  src={branding}
                  alt="Instagram content"
                  className="w-full h-full object-cover brightness-95 group-hover:brightness-105"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </div>
            <span className="px-4 py-2 text-sm font-medium tracking-wider text-[#704735] bg-white/90 rounded-full shadow-sm border border-[#704735]/30 transition-all duration-300 hover:border-[#704735]/60">
              on Instagram
            </span>
            <p className="absolute bottom-0 text-2xl italic text-[#704735] hidden md:block">
              @yourusername
            </p>
          </div>

          {/* TikTok Column */}
          <div className="group relative flex flex-col items-center space-y-4 lg:-mt-12">
            <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden shadow-lg">
              <div className="relative w-full h-full">
                <img
                  src={ContentCreation}
                  alt="TikTok content"
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                  <h2 className="text-7xl font-bold text-white italic transform -rotate-6 hover:scale-110 transition-transform duration-300">
                    Elsewhere
                  </h2>
                </div>
              </div>
            </div>
            <span className="px-4 py-2 text-sm font-medium tracking-wider text-[#704735] bg-white/90 rounded-full shadow-sm border border-[#704735]/30 transition-all duration-300 hover:border-[#704735]/60">
              on TikTok
            </span>
          </div>

          {/* YouTube and Twitter Column */}
          <div className="flex flex-col space-y-12">
            {/* Twitter Section */}
            <div className="group relative">
              <div className="relative w-full flex justify-end">
                <div className="w-[250px] h-[250px] rounded-2xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-2xl">
                  <div className="relative w-full h-full transform transition-transform group-hover:scale-105">
                    <img
                      src={Email}
                      alt="Twitter content"
                      className="w-full h-full object-cover brightness-95 group-hover:brightness-105"
                    />
                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                </div>
              </div>
              <span className="absolute right-4 top-4 px-4 py-2 text-sm font-medium tracking-wider text-[#704735] bg-white/90 rounded-full shadow-sm border border-[#704735]/30 transition-all duration-300 hover:border-[#704735]/60">
                on Twitter
              </span>
            </div>

            {/* YouTube Section */}
            <div className="group relative">
              <div className="w-full h-[350px] rounded-lg overflow-hidden shadow-lg mb-3 bg-gray-100">
                <video
                  ref={videoRef}
                  className="w-full h-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src={Youtube} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <span className="absolute right-4 bottom-4 px-4 py-2 text-sm font-medium tracking-wider text-[#704735] bg-white/90 rounded-full shadow-sm border border-[#704735]/30 transition-all duration-300 hover:border-[#704735]/60">
                on YouTube
              </span>
            </div>
            <p className="relative bottom-0 text-2xl italic text-[#704735] block md:hidden ">
              @yourusername
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection5;
